'use strict';

const { SHOW_CLASS, KEYCODE_TAB, EVENT_KEY_TAB, ANIM_TIME_QUICK_2, NO_SCROLL_CLASS, SHOW_ALL_CLASS } = require('../constants');
const { queryFirst, queryAll, addClass, hasClass, removeClass } = require('../domUtil');
const { destroySwiper, initCarouselElement, CLASS_CAROUSEL_INITIALIZED, SELECTOR_CAROUSEL_WRAPPER, SELECTOR_CLASS_SELECTOR_CAROUSEL } = require('../components/swiperCarousel').default;

const { body } = document;
const shopByPrintEl = queryFirst('.shop-by-print');
const toggleDrawerEl = queryFirst('.shop-by-print-drawer-content');
const videoComponentEl = queryFirst('.video-component');
const sbpOverlay = queryFirst('.shop-by-print-overlay');
const toggleButton = queryFirst('.view-all-carousel');
let clickedModalBtn = '';

/**
 * Open modal with print
 */
function openQuickview() {
    if (!hasClass(shopByPrintEl, SHOW_CLASS)) {
        addClass(shopByPrintEl, SHOW_CLASS);
        addClass(body, NO_SCROLL_CLASS);
    }
}

/**
 * Close modal with print
 */
function closeQuickview() {
    removeClass(shopByPrintEl, SHOW_CLASS);
    removeClass(body, NO_SCROLL_CLASS);
    if (clickedModalBtn) {
        clickedModalBtn.focus({
            preventScroll: true
        });
    }
}

toggleButton?.addEventListener('click', ev => {
    const carouselWrapper = ev.target.closest(SELECTOR_CAROUSEL_WRAPPER);
    const carouselEl = queryFirst(SELECTOR_CLASS_SELECTOR_CAROUSEL, carouselWrapper);
    if (hasClass(carouselEl, CLASS_CAROUSEL_INITIALIZED)) {
        destroySwiper(carouselEl);
        addClass(carouselWrapper, SHOW_ALL_CLASS);
    } else {
        initCarouselElement(carouselEl);
        removeClass(carouselWrapper, SHOW_ALL_CLASS);
    }
});

/**
 * Init modal with print
 * @param {HTMLElement} e the element that was clicked
 */
function handlePrintBtnClick(e) {
    const { target } = e;
    if (!target.matches('.shop-by-print-drawer-tile')) {
        return;
    }

    const { href } = e.target.dataset;
    clickedModalBtn = e.target;

    const quickviewEl = queryFirst('.shop-by-print-quickview');

    $.getJSON(href, function (data) {
        quickviewEl.innerHTML = data.renderedTemplate;
    }).done(function () {
        setTimeout(() => {
            openQuickview();

            const quickviewClose = queryFirst('.print-quickview-close');
            quickviewClose.focus({
                preventScroll: true
            });

            quickviewClose?.addEventListener('click', closeQuickview);

            // ADA: contain tabs within modal when active
            const handleQuickviewModalTab = e => {
                const isTabPressed = e.key === EVENT_KEY_TAB || e.keyCode === KEYCODE_TAB;
                if (!isTabPressed) {
                    return;
                }
                const focusable = queryAll('button:not(.d-md-none), [href]:not(.d-md-none), [tabindex]:not([tabindex="-1"])', quickviewEl);
                const lastFocusable = focusable[focusable.length - 1];

                if (e.target === lastFocusable) {
                    setTimeout(() => {
                        quickviewClose.focus();
                    }, ANIM_TIME_QUICK_2);
                }
            };

            if (quickviewEl) {
                quickviewEl.addEventListener('keydown', handleQuickviewModalTab);
            }
        }, ANIM_TIME_QUICK_2);
    });
}

module.exports = () => {
    if (videoComponentEl) {
        videoComponentEl.style.opacity = 1;
    }

    if (sbpOverlay) {
        sbpOverlay.addEventListener('click', closeQuickview);
    }

    if (toggleDrawerEl) {
        toggleDrawerEl.addEventListener('click', handlePrintBtnClick);
    }

    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' || e.key === 'Esc') {
            e.preventDefault();
            closeQuickview();
        }
    });
};
